import { SelectContactSearchPopover } from './select-contact-search.popover';
import { LookupExternalModel } from 'app/models/shared/lookup.model';
import { Constants } from 'app/utility/constants';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { FieldModel } from 'app/models/shared/field.model';
import { SecurityRight, SalesStatus } from 'app/utility/enums';
import { UserService } from 'app/services/user.service';
import { PRIMARY_OUTLET } from '@angular/router';
import { ContactListComponent } from '../contact-list/contact-list.component';
import { ContactService } from 'app/services/contact.service';
import { GeneralService } from 'app/services/general.service';
import { ContactType, ContactClass } from 'app/utility/enums';
import { ContactSearchParamsModel } from 'app/models/dms/contactSearchParams.model';
import { ModalController, IonSearchbar, LoadingController, AlertController, PopoverController, Platform } from '@ionic/angular';
import { ContactResultModel, ContactModel } from 'app/models/dms/contact.model';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { parsePhoneNumberFromString} from 'libphonenumber-js';
import { WizardSelectContactComponent } from 'app/components/wizard/wizard-select-contact/wizard-select-contact.component';
import { throwError } from 'rxjs';

import { ModalDetailsEditComponent } from 'app/components/shared/modal-details-edit/modal-details-edit.component';

@Component({
    selector: 'app-select-contact-search',
    templateUrl: './select-contact-search.component.html',
    styleUrls: ['./select-contact-search.component.scss'],
    standalone: false
})
export class SelectContactSearchComponent implements OnInit
{
	@Input() title: string;
	@Input() value: string;

	@Input() selectedContact: ContactResultModel;
	@Input() selectedContactId: string;
	@Input() contactClass: ContactClass;
	@Input() contactType: ContactType;
	@Input() salesStatus: SalesStatus = SalesStatus.None;
	@Input() placeholderText: string = "Search contacts";

	@ViewChild('searchbar') searchbar: IonSearchbar;

	@ViewChild('contacts') contacts: ContactListComponent;

	searchParams: ContactSearchParamsModel;

	searchActive: boolean = false;
	searchQuery: string;
	currentVal: string;

	searchSuggestions: string[];
	searchSuggestionsIndex: string[];

	contactTemplate: ContactModel;
	blurPending: boolean = false;
	isMobile: boolean = false;

	constructor(
		public modalController: ModalController,
		private contactService: ContactService,
		private loadingController: LoadingController,
		private popoverController: PopoverController,
		private userService: UserService,
		private alertController: AlertController,
		private platform: Platform,
	) { }

	ngOnInit()
	{
		this.searchActive = false;
		this.initSearchParams();
		this.initializeSearchSuggestions();

		if (this.platform.width() > 990) {
			setTimeout(() =>
			{
				this.searchbar.setFocus();
			}, 500);
		}

		this.platform.ready().then(() =>
		{
			this.isMobile = (this.platform.width() < 1024);
			this.platform.resize.subscribe(() =>
			{
				this.isMobile = (this.platform.width() < 1024);
			});
		});
	}

	ngAfterInit()
	{
	}

	private initSearchParams()
	{
		this.searchParams = new ContactSearchParamsModel();
		this.searchParams.contactType = this.contactType;
		this.searchParams.contactClass = this.contactClass;
		this.searchParams.salesStatus = this.salesStatus;
		this.searchParams.searchText = '';
		this.searchParams.pageNumber = 1;
		this.searchParams.pageSize = 12;
		this.searchParams.filterByAccountOwnerId = false;
		// console.log(this.searchParams);
	}

	public dismissModal(save: boolean = false)
	{
		if (save)
		{
			// Dismiss the top modal returning some data object
			this.modalController.dismiss({
				contact: this.selectedContact
			});
		}
		else
		{
			this.modalController.dismiss();
		}
	}

	private initializeSearchSuggestions()
	{
		this.searchSuggestionsIndex = [];
		// console.log("initializeSearchSuggestions", this.searchParams.contactClass, this.searchParams.contactType, this.searchParams.filterByAccountOwnerId);
		this.contactService.getCachedContactsIndex(this.searchParams.contactClass, this.searchParams.contactType, this.searchParams.filterByAccountOwnerId, this.searchParams.salesStatus)
			.subscribe({
				next: x =>
				{
					this.searchSuggestionsIndex = x;
					// console.log(x);
				},
				error: err =>
				{
					console.error(err);
				}
            });
	}

	public getSearchSuggestions(ev: any)
	{
		// set val to the value of the searchbar
		const val = ev.target.value;

		// if the value is an empty string don't filter the items
		if (val && val.trim() != '')
		{
			this.setSearchSuggestions(val);
			this.searchActive = true;
		}
		else
		{
			this.searchActive = false;
		}
	}

	public clearSearchSuggestions(): void
	{
		this.searchActive = false;

		setTimeout(() =>
		{
			this.searchbar.setFocus();
		}, 5);
	}

	public cancelSearch()
	{
		this.searchActive = false;
	}

	private setSearchSuggestions(val: string)
	{
		if (val.length >= 2)
		{
			this.currentVal = val;
			this.searchSuggestions = this.searchSuggestionsIndex.filter((item) =>
			{
				return (item.toLowerCase().indexOf(val.toLowerCase()) == 0);
			}).slice(0, 15).concat((this.searchSuggestionsIndex.filter((item) =>
			{
				return (item.toLowerCase().indexOf(val.toLowerCase()) > 0);
			}).slice(0, 15)));
		}
		else
		{
			return [];
		}
	}

	public setSearch(item)
	{
        this.searchQuery = item;
		setTimeout(() =>
		{
			this.runSearch();
		}, 5);
	}

	public onKeypress(event: any)
	{
		if (event && event.key === 'Enter')
		{
			// console.log("searchItems", this.searchQuery);
			this.runSearch();
			event.srcElement.blur();
		}
	}

	public doSearch(event: any)
	{
        this.searchQuery = (event.target && event.target.value)?event.target.value:'';
        this.currentVal = this.searchQuery;
		setTimeout(() =>
		{
			this.runSearch();
		}, 5);
		if (event.srcElement) {
			event.srcElement.blur();
		}
	}

	public runSearch()
	{
		this.searchActive = false;
		this.searchParams.searchText = this.searchQuery;
	}
	public toggleSearch()
	{

	}

	public name: string;
	public field_groups: FieldGroupModel[];
	async addContact(ev: any, name: string = "")
	{

		this.name = name;
		if (this.contactClass == ContactClass.All || this.contactType == ContactType.All)
		{
			const popover = await this.popoverController.create({
				component: SelectContactSearchPopover,
				componentProps: {
					title: 'Status',
					contactClass: this.contactClass,
					contactType: this.contactType,
					event: ev,
				}
			});

			popover.onDidDismiss().then(
				(d: any) => this.handlePopoverDismiss(d)
			);
			return await popover.present();
		}
		else
		{
			this.createContact(this.contactClass, this.contactType);
		}

	}

	handlePopoverDismiss = ({ data }) =>
	{
		switch (data.action)
		{
			case "customer-individual":
				this.createContact(ContactClass.Individual, ContactType.Customer);
				break;
			case "customer-company":
				this.createContact(ContactClass.Business, ContactType.Customer);
				break;
			case "supplier-individual":
				this.createContact(ContactClass.Individual, ContactType.Supplier);
				break;
			case "supplier-company":
				this.createContact(ContactClass.Business, ContactType.Supplier);
				break;
		}
	}

	async createContact(contactClass: ContactClass, contactType: ContactType)
	{
		var name = this.name;
		this.contactService.getContactTemplate(contactClass, this.contactType)
			.subscribe(x =>
			{
				// console.log(x);
				this.contactTemplate = x;
				var create_contact_fields = this.getCreateContactFields(contactClass, contactType);


				this.launchContactEditor(create_contact_fields, (name != ''));
			});
		//   const loading = await this.loadingController.create({
		//     message: 'Saving'
		//   });
	}

	async launchContactEditor(create_contact_fields: FieldGroupModel[], isDirty: boolean = false)
	{
		const modal = await this.modalController.create({
			component: ModalDetailsEditComponent,
			componentProps: {
				'title': 'Add New Contact',
				'edit': true,
				'field_groups': create_contact_fields,
				'isDirty': isDirty
			}
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		if (data && data.result && data.result.save)
		{
			var contact = this.syncFormWithObject(this.contactTemplate, create_contact_fields);

			const loading = await this.loadingController.create({
				message: 'Saving',
				duration: 60000
			});
			await loading.present();
			this.contactService.saveContact(contact).subscribe
				({
					next: x =>
					{
						loading.dismiss();
						setTimeout(() =>
						{
							this.modalController.dismiss({
								contact: x.contactSummary
							});
						}, 5);
					},
					error: err =>
					{
						loading.dismiss();
						this.launchContactEditor(create_contact_fields, true);
						this.handleError(err);
					}
                });
		}
		else
		{
			// console.log("New contact cancelled");
		}
	}

	async contactSelected(contact: ContactResultModel)
	{
		this.selectedContact = contact;
		this.selectedContactId = contact.id;
		// console.log("Contact Selected", contact);
		this.dismissModal(true);
	}

	async newContactSelected(name: string)
	{
		// console.log("New contact ", name);
		this.addContact(null, name);
	}

	public canAdd(): boolean
	{
		return (this.userService.hasUserRight(SecurityRight.ContactFunctionsCreate) && (this.contactType == "Customer" || this.contactType == "Supplier"));
	}

	public TryPopulatePhoneOrEmailBasedOnSearch() : boolean {
		const phoneNumber = parsePhoneNumberFromString(this.searchQuery, "NZ");
		if (new WizardSelectContactComponent(null, null, null, null, null, null, null, null, null, null).validEmail(this.searchQuery)) {
			this.contactTemplate.contactGeneral.primaryEmail = this.searchQuery;
			return true;
		}
		if(phoneNumber) {
			this.contactTemplate.contactGeneral.phone = this.contactTemplate.contactGeneral.mobile = phoneNumber.formatNational();
			return true;
		}
		return false;
	}

	public getCreateContactFields(contactClass: ContactClass, contactType: ContactType, firstName: string = "", lastName: string = ""): FieldGroupModel[]
	{
		var field_groups: FieldGroupModel[] = [];
		var group_1 = new FieldGroupModel("Add " + contactClass);

		//if search is a mobile number, populate contactGeneral.mobile with the value from this.currentVal

		//else if search is an email, contactTemplate.contactGeneral.primaryEmail from  this.currentVal

		//else populate name this.contactTemplate.contactGeneral.name

		const autopopulatedEmailOrPhone = this.TryPopulatePhoneOrEmailBasedOnSearch();

		if (contactClass == ContactClass.Business)
		{
			if (!autopopulatedEmailOrPhone) {
				this.contactTemplate.contactGeneral.name = this.currentVal?this.currentVal:"";
			}
			group_1.addField(new FieldModel("Company name", this.contactTemplate.contactGeneral.name, "text", "name", true, true));
			group_1.addField(new FieldModel("Phone", this.contactTemplate.contactGeneral.phone, "tel", "phone"));
			group_1.addField(new FieldModel("Email address", this.contactTemplate.contactGeneral.primaryEmail, "email", "primaryEmail"));
			group_1.addField(new FieldModel("Website", this.contactTemplate.contactGeneral.website, "url", "website"));
		}
		//else this is an individual
		else
		{
			if (!autopopulatedEmailOrPhone) {
				var firstname = "";
				var lastname = "";
				if (this.currentVal && this.currentVal.length > 0)
				{
					var index = this.currentVal.indexOf(" ");
					if (index)
					{
						firstname = this.currentVal.substr(0, index);
						lastname = this.currentVal.slice(index).trim();
					}
					else
					{
						lastname = this.currentVal;
					}
				}
				this.contactTemplate.contactGeneral.firstName = firstname;
				this.contactTemplate.contactGeneral.name = lastname;
			}
			group_1.addField(new FieldModel("First name", this.contactTemplate.contactGeneral.firstName, "text", "firstName", true, true));
			group_1.addField(new FieldModel("Last name", this.contactTemplate.contactGeneral.name, "text", "name", true, true));
			group_1.addField(new FieldModel("Mobile", this.contactTemplate.contactGeneral.mobile, "tel", "mobile"));
			group_1.addField(new FieldModel("Email", this.contactTemplate.contactGeneral.primaryEmail, "email", "primaryEmail"));
		}

		if (contactType == ContactType.Customer)
		{
			var referralMethod = new LookupExternalModel();
			referralMethod.id = Constants.EmptyGuid;
			referralMethod.collection = "ReferralMethod";
			referralMethod.lookupType = "External";
			// create a new group for the below?
			group_1.addField(new FieldModel("Referral method", Constants.EmptyGuid, "lookup", "referralMethodId", true, false, referralMethod, "", 'None'));
		}

		field_groups.push(group_1);
		return field_groups;
	}



	public syncFormWithObject(data: ContactModel, fieldGroups: FieldGroupModel[]): ContactModel
	{
		var data_changed = false;

		for (let field_group of fieldGroups)
		{
			for (let field of field_group.fields)
			{
				// console.log(data.contactGeneral[field.id]);
				if (data.contactGeneral[field.id] != null && data.contactGeneral[field.id] != field.value && !field.invalid && field.dirty)
				{
					data_changed = true;
					data.contactGeneral[field.id] = field.value;
				}
			}
		}
		return data;
	}


	public handleError(error: any): void
	{
		this.userService.handleError(error);
	}


	async doRefresh(ev: any)
	{
		this.doSearch({});


		setTimeout(() =>
		{
			ev.target.complete();

		}, 1500);
	}

	scrollTop: boolean = true;
	ionScrollEvent(ev:any){
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop!=scrollTop) {
			this.scrollTop = scrollTop;
		}
	}

	untoggleSearch(ev:any = null, desktopOnly: boolean = false)
	{
		if (desktopOnly && this.isMobile) {
			return;
		}

		this.blurPending = true;

		setTimeout(() =>
		{
			if (this.blurPending) {
				this.blurPending = false;
				this.searchActive = false;
				if (this.searchQuery != this.searchParams.searchText) {
					this.searchQuery = this.searchParams.searchText;
				}
			}
		}, 300);

	}
}
